import { Typography, useMediaQuery } from "@mui/material";
import { Box, SxProps } from "@mui/system";
import bannerSrc from "@arelia-assets/banner1.jpg";
import theme from "src/theme";

type Props = {
  title: string;
  banner?: string;
};

export default function UnauthorizedHeader({ title, banner }: Props) {
  const isMd = useMediaQuery(theme.breakpoints.down("md"));

  const sx: SxProps = {
    p: isMd ? 2 : 5,
    pb: isMd ? 0 : 2,
    background: `url(${banner ?? bannerSrc}) no-repeat`,
    backgroundPosition: "0 0",
    backgroundSize: isMd ? "130% auto" : "100% auto",
  };

  return (
    <Box sx={sx}>
      <Box sx={{ zIndex: 2, position: "relative" }}>
        <Box display="flex" mb={8}>
          {/* <Box ml="auto" display="flex" gap={2}>
            <a href="https://areliatech.com/arelia-university" target="_blank" rel="noopener noreferrer">
              <IconButton color="secondary">
                <ContactSupportOutlinedIcon />
              </IconButton>
            </a>
          </Box> */}
        </Box>
        <Box
          borderBottom={0}
          borderColor="#e2e2e2"
          pb={1}
          display="flex"
          justifyContent="center"
          alignItems="flex-start"
          flexDirection="column"
        >
          <Box
            display="flex"
            alignItems="center"
            width="100%"
          >
            <Typography
              variant="h1"
              sx={{
                color: "#F7F8FA",
                marginRight: "0",
                width: "100%",
              }}
            >
              {title}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}